import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import axios from 'axios';
import ProductForm from './ProductForm';

const ProductEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://pcvasquez.com/api/products/${id}`);
        setProductData(response.data);
      } catch (error) {
        console.error('Error al cargar el producto:', error);
        toast.error('Error al cargar el producto', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          className: "border-l-4 border-red-500 bg-white shadow-lg"
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProduct();
    }
  }, [id]);

  const handleProductSubmit = (updatedProduct) => {
    console.log('Producto actualizado:', updatedProduct);
    toast.success('Producto actualizado exitosamente', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      className: "border-l-4 border-green-500 bg-white shadow-lg"
    });
    
    setTimeout(() => {
      navigate('/admin/products');
    }, 1000);
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-[#0C4B45]/5 to-white p-6">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0C4B45]"></div>
        <p className="mt-4 text-xl font-medium text-[#0C4B45]">Cargando producto...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0C4B45]/5 to-white p-6">
      <ProductForm 
        mode="edit" 
        productId={id}
        productData={productData}
        onSubmit={handleProductSubmit} 
        onCancel={() => navigate('/admin/products')}
      />
    </div>
  );
};

export default ProductEdit;